import { FC, ReactNode } from 'react'
import { useRouter } from 'next/router'
import { Link } from '@/libs'
import { SidebarList } from '@/data'
import { ActivePath } from '@/helpers'
import { useSize } from '@/hooks'

const Sidebar: FC = (): ReactNode => {
    const router = useRouter()

    const { isMobile } = useSize()

    return (
        <aside className={`h-full bg-[#262626] border-r border-[#424242] transition-all ease-in-out duration-500 ${(!isMobile) ? 'w-72' : 'w-auto'}`}>
            <div className='px-3 space-y-2 py-4 h-full overflow-y-auto'>
                {
                    SidebarList.map((item: SidebarItemTypes) => {
                        const { name, icon: Icon, path } = item

                        const active = ActivePath(router, path)

                        let container_class = active ? 'select-none flex items-center p-2 text-base font-normal text-[#EBEBEB] rounded-md bg-[#2E2E2E] transition-all ease-in-out duration-500' : 'select-none flex items-center p-2 text-base font-normal text-[#EBEBEB] rounded-md hover:bg-[#2E2E2E] transition-all ease-in-out duration-500'
                        let icon_class = active ? 'flex-shrink-0 w-6 h-6 text-[#EBEBEB]' : 'flex-shrink-0 w-6 h-6 text-[#CDD5DA]'

                        return (
                            <Link
                                key={name}
                                href={path}
                                className={container_class}
                            >
                                <Icon className={icon_class} />

                                {
                                    !isMobile &&
                                    <span className='ml-2.5'>
                                        {name}
                                    </span>
                                }
                            </Link>
                        )
                    })
                }
            </div>
        </aside>
    )
}

export default Sidebar
